import script from "./CabinetHtmlify.vue?vue&type=script&lang=ts"
export * from "./CabinetHtmlify.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__